// extracted by mini-css-extract-plugin
export default {"specifications":"AddSpecificationModalContent-specifications-x_4O_"};